import React, { useState } from 'react';
import Swal from 'sweetalert2';
import authService from '../services/authService';
import './Login.css';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      setError('Please fill in all fields');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await authService.login(formData.email, formData.password);
      onLogin(response.user);
    } catch (error) {
      setError(error.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  const fillDemoCredentials = () => {
    setFormData({
      email: 'john.doe@example.com',
      password: 'Mypassword123'
    });
    setError('');

    Swal.fire({
      title: 'Demo Credentials Loaded',
      text: 'You can now login with demo account',
      icon: 'success',
      timer: 2000,
      showConfirmButton: false,
      toast: true,
      position: 'top'
    });
  };

  const handleForgotPassword = () => {
    Swal.fire({
      title: 'Reset Password',
      text: 'Please contact system administrator to reset your password.',
      icon: 'info',
      confirmButtonText: 'OK',
      confirmButtonColor: '#4f46e5'
    });
  };

  const handlePosLogin = () => {
    window.open('https://cashier.litegrocer.lk', '_blank');
  };

  const handleEcommerceSite = () => {
    window.open('https://litegrocer.lk', '_blank');
  };

  return (
    <div className="loginAdminContainer">
      <div className="loginSplitWrapper">
        {/* Left Side - Brand Showcase */}
        <div className="loginShowcasePanel">
          <div className="showcaseContent">
            <div className="showcaseLogoWrapper">
              <img src="/logo.svg" alt="Lite Grocer" className="showcaseLogo" />
              <div className="showcaseGlow"></div>
            </div>
            <h1 className="showcaseTitle">Lite Grocer</h1>
            <p className="showcaseSubtitle">Empowering your grocery business with seamless management tools and real-time insights.</p>
            
            <div className="showcaseFeatures">
              <div className="featureItem">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <span>Real-time Inventory</span>
              </div>
              <div className="featureItem">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
                <span>Unified POS & Web</span>
              </div>
              <div className="featureItem">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <span>Staff Management</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="loginFormPanel">
          <div className="loginFormContainer">
            <div className="loginHeader">
              <h2 className="welcomeTitle">Welcome Back</h2>
              <p className="welcomeSubtitle">Sign in to your administration dashboard</p>
            </div>

            <form onSubmit={handleSubmit} className="loginForm">
              <div className="formGroup">
                <label htmlFor="email" className="formLabel">Email Address</label>
                <div className="inputContainer">
                  <div className="inputIcon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </div>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Enter your email address"
                    className="formInput"
                  />
                </div>
              </div>

              <div className="formGroup">
                <div className="labelRow">
                  <label htmlFor="password" className="formLabel">Password</label>
                  <button
                    type="button"
                    className="forgotPasswordButton"
                    onClick={handleForgotPassword}
                  >
                    Forgot password?
                  </button>
                </div>
                <div className="inputContainer">
                  <div className="inputIcon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    </svg>
                  </div>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    placeholder="Enter your password"
                    className="formInput"
                  />
                </div>
              </div>

              <div className="formOptions">
                <label className="checkboxLabel">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="checkboxInput"
                  />
                  <span className="checkmark"></span>
                  Remember me
                </label>
              </div>

              {error && (
                <div className="errorMessage">
                  <div className="errorIcon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                  </div>
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="loginButton"
              >
                {loading ? (
                  <div className="buttonLoading">
                    <div className="spinner"></div>
                    Signing in...
                  </div>
                ) : (
                  <>
                    <span className="buttonText">Sign In</span>
                    <div className="buttonIcon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                      </svg>
                    </div>
                  </>
                )}
              </button>
            </form>

            <div className="quickActions">
              <div className="divider">
                <span>Quick Access</span>
              </div>
              <div className="actionButtons">
                <button type="button" className="actionButton demoButton" onClick={fillDemoCredentials}>
                  <div className="actionIcon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
                    </svg>
                  </div>
                  <span>Demo Account</span>
                </button>
                <button type="button" className="actionButton posButton" onClick={handlePosLogin}>
                  <div className="actionIcon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                      <line x1="8" y1="21" x2="16" y2="21" />
                      <line x1="12" y1="17" x2="12" y2="21" />
                    </svg>
                  </div>
                  <span>POS System</span>
                </button>
                <button type="button" className="actionButton storeButton" onClick={handleEcommerceSite}>
                  <div className="actionIcon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                      <polyline points="9 22 9 12 15 12 15 22" />
                    </svg>
                  </div>
                  <span>Online Store</span>
                </button>
              </div>
            </div>

            <div className="loginFooter">
              <div className="copyright">
                &copy; 2026 <a href="https://www.ellipza.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>Ellipza</a>. All rights reserved.
              </div>
              <div className="version-info">
                <small>v2.0.1</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;